import { useContext } from 'react';

import { ThemeContext, Tooltip } from '@suntex.fim/ui';

export function ReportHeaderTooltip({ value }: { value: string }) {
  const theme = useContext(ThemeContext);
  const label = theme?.localize?.(value) ?? value;
  return (
    <Tooltip
      title={label}
      classNames={{ root: 'progress-tooltip' }}
      arrow={false}
    >
      {label}
    </Tooltip>
  );
}
